import triggerPostback from './triggerPostback';

export default triggerPostback;
